import { db } from "@/firebaseConfig";

const qrZoneCollection = db.collection("zone_tables_qr");

const saveQrZone = async data => {
  qrZoneCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("QrZone successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateQrZone = async (id, data) => {
  qrZoneCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("QrZone successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteQrZone = async id => {
  qrZoneCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("QrZone successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getQrZoneById = async id => {
  return qrZoneCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getQRZones = () => {
  return qrZoneCollection
    .get()
    .then(querySnapshot => {
      let result = [];
      querySnapshot.forEach(doc => {
        result.push({ id: doc.id, ...doc.data() });
      });

      return result;
    })
    .catch(error => {
      throw error;
    });
};

export {
  qrZoneCollection,
  saveQrZone,
  updateQrZone,
  deleteQrZone,
  getQrZoneById,
  getQRZones
};
